<template>
  <div class="articles-table">
    <!-- Table -->
    <v-data-table
      :loading="isLoading"
      v-model="selectedArticles"
      :headers="headers"
      :items="articles"
      :items-per-page="-1"
      hide-default-footer
      :show-select="showSelect"
      item-key="reference"
      @click:row="editArticle"
    >
      <template v-slot:item.total_article_ht="{ item }">
        {{ item.total_article_ht | currency }}
      </template>
    </v-data-table>

    <!--Total  -->
    <v-layout align-center>
      <v-flex>
        <p style="text-align: right" class="ma-0">Montant Total hors Taxe</p>
      </v-flex>
      <v-flex sm3 ml-2>
        <v-text-field
          outlined
          hide-details
          :value="total_amount | currency"
          readonly
        ></v-text-field>
      </v-flex>
    </v-layout>

    <!-- Options -->
    <v-layout
      justify-space-between
      align-center
      class="btn-container mt-4"
      wrap
      v-if="!isGeneral"
    >
      <v-btn block class="mb-2" @click="importArticles"
        >Importer depuis fiche applicateur</v-btn
      >

      <v-dialog v-model="dialog" persistent max-width="500">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on">Nouveau</v-btn>
        </template>
        <v-card>
          <v-card-title class="headline px-8" v-if="!editMode"
            >Ajouter un Accessoire</v-card-title
          >
          <v-card-title class="headline px-8" v-else
            >Modifification accessoire
          </v-card-title>

          <v-card-text class="px-8">
            <h1 v-if="editMode && selectedArticle">
              {{ selectedArticle.reference }}
            </h1>
            <v-text-field
              v-if="!editMode"
              v-model="searchTerm"
              label="Recherche"
              @input="searchArticles"
            ></v-text-field>

            <v-list v-if="!editMode" shaped>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(article, i) in searchResults"
                  :key="i"
                  @click="selectedArticle = article"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      v-html="article.article_reference"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>

            <template v-if="selectedArticle">
              <v-layout my-4 px-2 align-center justify-space-between>
                <h2 class="modal_quantity ma-0">Quantité</h2>
                <v-flex sm3 ml-4>
                  <InputNumber
                    v-model="selectedArticleQty"
                    class="input-number"
                  />
                </v-flex>
              </v-layout>
              <template v-if="!editMode">
                <v-layout align-center justify-space-between wrap>
                  <p>Prix unitaire HT</p>
                  <p>{{ selectedArticle.amount_ht | currency }}</p>
                </v-layout>
                <v-layout align-center justify-space-between wrap>
                  <p>Taux TVA</p>
                  <p>{{ selectedArticle.tva_rate | vat }}</p>
                </v-layout>
                <v-layout align-center justify-space-between wrap>
                  <p>Prix unitaire TTC</p>
                  <p>{{ selectedArticle.amount_ttc | currency }}</p>
                </v-layout>
                <v-layout justify-space-between align-center>
                  <v-flex sm6>
                    <v-layout align-center wrap>
                      <p class="mr-2">Total HT :</p>
                      <p>{{ totalHt | currency }}</p>
                    </v-layout>
                  </v-flex>
                  <v-flex sm6>
                    <v-layout align-center wrap>
                      <p class="mr-2">Total TTC :</p>
                      <p>{{ totalTtc | currency }}</p>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </template>
            </template>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-layout align-center justify-end pr-6>
              <v-btn color="green darken-1" text @click="resetDialog"
                >Annuler</v-btn
              >
              <v-btn
                color="green darken-1"
                text
                v-if="!editMode"
                @click="addArticle"
                >Valider</v-btn
              >
              <v-btn color="green darken-1" text v-else @click="updateArticle"
                >Modifier</v-btn
              >
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-btn @click="deleteArticle">Supprimer</v-btn>
    </v-layout>
  </div>
</template>

<script>
  import { mapActions } from "vuex";

  import InputNumber from "@/components/InputNumber.vue";

  import ArticleRepo from "@/repositories/articlesRepo.js";

  export default {
    name: "ArticlesTable",
    components: {
      InputNumber
    },
    props: {
      type: {
        type: String,
        default: "GENERAL"
      },
      productModel: String,
      showSelect: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        headers: [
          {
            text: "Traiter",
            value: "reference"
          },
          {
            text: "Lpp",
            value: "label"
          },
          {
            text: "Qté",
            value: "quantity"
          },
          {
            text: "Total HT",
            value: "total_article_ht"
          }
        ],

        isLoading: false,

        searchTerm: null,
        searchResults: [],
        selectedArticle: null,
        selectedArticleQty: 1,
        selectedArticles: [],
        editMode: false,

        articles: [],
        total_amount: null,
        dialog: false
      };
    },
    computed: {
      isGeneral() {
        return this.type === "GENERAL";
      },

      totalHt() {
        if (!this.selectedArticle) {
          return;
        }

        return this.selectedArticle.amount_ht * this.selectedArticleQty;
      },

      totalTtc() {
        if (!this.selectedArticle) {
          return;
        }

        return this.selectedArticle.amount_ttc * this.selectedArticleQty;
      }
    },
    methods: {
      ...mapActions({
        fetchProjectArticles: "projects/fetchProjectArticles"
      }),

      async updateArticle() {
        const payload = {
          id: this.selectedArticle.article_id,
          quantity: this.selectedArticleQty
        };

        await this.$store.dispatch("projects/updateProjectArticle", {
          project_uuid: this.$route.params.project_uuid,
          payload
        });

        this.init();

        this.resetDialog();
      },

      editArticle(article) {
        this.editMode = true;
        this.selectedArticle = article;
        this.selectedArticleQty = article.quantity;
        this.dialog = true;

        console.log(article);
      },

      async deleteArticle() {
        let articleList = [];

        this.selectedArticles.map(article => {
          const obj = { id: article.article_id };
          articleList.push(obj);
        });

        if (articleList.length <= 0) return;

        await this.$store.dispatch("projects/deleteProjectArticles", {
          project_uuid: this.$route.params.project_uuid,
          payload: { article_list: articleList }
        });

        this.init();
      },

      resetDialog() {
        this.dialog = false;
        this.editMode = false;
        this.searchTerm = null;
        this.selectedArticle = null;
        this.selectedArticleQty = 1;
        this.searchResults = [];
      },

      async addArticle() {
        this.isLoading = true;

        const payload = {
          id: this.selectedArticle.id,
          quantity: this.selectedArticleQty
        };

        try {
          await this.$store.dispatch("projects/createProjectArticle", {
            project_uuid: this.$route.params.project_uuid,
            payload
          });

          this.resetDialog();

          this.init();

          this.isLoading = false;
        } catch (error) {
          this.init();
          if (
            error &&
            error.response.data.error == "ERR_ARTICLE_LINK_ALREADY_EXIST"
          ) {
            alert("Article existant");
          }
        }
      },

      async searchArticles() {
        // We need at least 3 characters
        if (!this.searchTerm || this.searchTerm.length < 3) {
          this.searchResults = [];
          return;
        }

        console.log("Searching...", this.searchTerm);

        const { data } = await ArticleRepo.fetchArticles(
          this.productModel,
          this.searchTerm
        );
        this.searchResults = data;
        console.log(data);
      },

      // Load articles
      async init() {
        this.isLoading = true;

        const project_uuid = this.$route.params.project_uuid;
        const response = await this.fetchProjectArticles({
          project_uuid: project_uuid,
          type: this.type
        });

        this.articles = response.articles;
        this.total_amount = response.total_amount_ht;

        this.isLoading = false;
      },

      async importArticles() {
        this.isLoading = true;

        const { articles } = await this.fetchProjectArticles({
          project_uuid: this.$route.params.project_uuid,
          type: "GENERAL"
        });

        articles.map(async article => {
          const art = this.articles.find(
            art => art.article_id == article.article_id
          );

          if (art) {
            return;
          }

          const payload = {
            id: article.article_id,
            quantity: article.quantity
          };

          await this.$store.dispatch("projects/createProjectArticle", {
            project_uuid: this.$route.params.project_uuid,
            payload
          });

          this.init();
        });

        this.isLoading = false;
      }
    },
    mounted() {
      this.init();
    }
  };
</script>

<style lang="scss">
  .articles-table {
    position: relative;
  }
</style>
